import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { Meta } from '../Announcement/types';
import { FiltersInvoice, InvoiceResponse } from './useGetInvoice';

export const QUERY_GET_INVOICES_V2 = 'QUERY_GET_INVOICES_V2';

export function useGetInvoicesV2(
    filters: FiltersInvoice,
    enableRequest: boolean,
) {
    const getInvoices = async () => {
        const response = await api.get<InvoiceResponse>(`erp/v2/invoices`, {
            params: {
                ...filters,
            },
        });
        return response.data;
    };

    return useQuery({
        queryKey: [QUERY_GET_INVOICES_V2, filters],
        queryFn: getInvoices,
        retry: false,
        refetchOnWindowFocus: false,
        enabled: enableRequest,
    });
}
